export const mf = "@newsenec/micro-frontend-manager";
export const mfShorty = "MFM";
export enum ErrorSerial {
    UnleashNotInitialized = "1001",
}
